import { ControllerBase } from "controllerBase";
const Mustache = require('mustache')
import global from 'globalMU'

declare var window:any


const CompararProdutosController = ControllerBase.extend({
    name: "CompararProdutosController",

    template: "#template-comparar-produtos",


    ajax: function() {
        return {
            url: "/Produto/_CompararProdutos",
            type: "get",
            cache: false
        };
    },

    renderizado: function() {
        $("#_compararProduto-region").html(Mustache.render($(this.template).html(),
        {
            produtos: this.collection
        }));

        this.obterParametrosInfo(false);

        if (this.collection.length)
            this.esconderElemento(this.collection);
    },

    esconderElemento: function (collection) {
        if (collection[0].DescricaoTipoEntrega !== undefined) {
            $("#comparar-produtos-region").find("#descricao-tipo-entrega").show();
        } else {
            $("#comparar-produtos-region").find("#descricao-tipo-entrega").hide();
        }

        if (collection[0].FilialRetirada !== undefined) {
            $("#comparar-produtos-region").find("#filial-de-retirada").show();
        } else {
            $("#comparar-produtos-region").find("#filial-de-retirada").hide();
        }

        if (collection[0].QuantidadeEstoqueFormatado !== undefined) {
            $("#comparar-produtos-region").find("#linha-quantidade-disponivel").show();
        } else {
            $("#comparar-produtos-region").find("#linha-quantidade-disponivel").hide();
        }

        if (collection[0].QuantidadeEstoqueFilial !== undefined) {
            $("#comparar-produtos-region").find("#quantidade-estoque-filial").show();
        } else {
            $("#comparar-produtos-region").find("#quantidade-estoque-filial").hide();
        }

        if (collection[0].QuantidadeEstoqueCD !== undefined) {
            $("#comparar-produtos-region").find("#quantidade-estoque-cd").show();
        } else {
            $("#comparar-produtos-region").find("#quantidade-estoque-cd").hide();
        }

        if (collection[0].QuantidadeEstoqueOutraFilial !== undefined) {
            $("#comparar-produtos-region").find("#quantidade-estoque-outra-filial").show();
        } else {
            $("#comparar-produtos-region").find("#quantidade-estoque-outra-filial").hide();
        }
    },

    obterParametrosInfo: function(async) {
        this.obterParametro("EXIBIR_QUANTIDADE_ESTOQUE_CONSULTA_PRODUTOS", async);
        this.obterParametro("EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS", async);
        this.obterParametro("EXIBIR_QUANTIDADE_MINIMA_VENDA_CONSULTA_PRODUTOS", async);
    },

    obterParametro: function(nomeInterno, async) {

        var pesquisa = {
            nomeInterno: nomeInterno
        };

        var self = this;

        global.ajax({
            url: "/Usuario/_ObterParametro",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(pesquisa),
            async: async,
            success: function(data) {
                self.esconderDiv(pesquisa.nomeInterno, data);
            }
        });
    },

    esconderDiv: function(nomeInterno, valorParametro) {

        switch (nomeInterno) {
        case "EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS":
            if (valorParametro != "S")
                $("#comparar-produtos-region").find("#linha-comissao-venda").remove();
            else
                $("#comparar-produtos-region").find("#linha-comissao-venda").show();
            break;
        case "EXIBIR_QUANTIDADE_ESTOQUE_CONSULTA_PRODUTOS":
            if (valorParametro != "S")
                $("#comparar-produtos-region").find("#linha-quantidade-disponivel").remove();
            else
                $("#comparar-produtos-region").find("#linha-quantidade-disponivel").show();
            break;
        case "EXIBIR_QUANTIDADE_MINIMA_VENDA_CONSULTA_PRODUTOS":
            if (valorParametro != "S")
                $("#comparar-produtos-region").find("#linha-quantidade-minima-venda").remove();
            else
                $("#comparar-produtos-region").find("#linha-quantidade-minima-venda").show();
            break;
        }
    }

})

window.CompararProdutosController = CompararProdutosController

export {
    CompararProdutosController
}